import React, { useState } from "react";
import { FaUserPlus, FaTimes, FaUser, FaEnvelope, FaLock, FaUniversity, FaIdBadge, FaUserGraduate } from "react-icons/fa";
import api from "../utils/api";

export default function AddUserModal({ isOpen, onClose, onUserAdded }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "student",
    campus: "Isulan",
    studentId: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await api.post("/auth/register", formData);
      onUserAdded();
      onClose();
      setFormData({
        name: "",
        email: "",
        password: "",
        role: "student",
        campus: "Isulan",
        studentId: ""
      });
    } catch (error) {
      setError(error.response?.data?.error || "Failed to create user");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="relative bg-gray-900 p-8 rounded-2xl shadow-2xl w-full max-w-md mx-2 animate-fadeIn">
        {/* Close button with tooltip */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-white text-2xl font-bold focus:outline-none group"
          aria-label="Close"
        >
          <FaTimes />
          <span className="absolute right-8 top-1/2 -translate-y-1/2 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none z-50">Close</span>
        </button>
        <div className="flex items-center justify-center gap-2 mb-6">
          <FaUserPlus className="text-green-400 text-2xl" />
          <h2 className="text-2xl font-bold text-white text-center">Add New User</h2>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-200 flex items-center gap-2">
              <FaUser className="text-gray-400" /> Name
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full p-3 rounded-lg bg-gray-800 text-white focus:ring-2 focus:ring-green-500 focus:outline-none transition"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-200 flex items-center gap-2">
              <FaEnvelope className="text-gray-400" /> Email
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full p-3 rounded-lg bg-gray-800 text-white focus:ring-2 focus:ring-green-500 focus:outline-none transition"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-200 flex items-center gap-2">
              <FaLock className="text-gray-400" /> Password
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              className="w-full p-3 rounded-lg bg-gray-800 text-white focus:ring-2 focus:ring-green-500 focus:outline-none transition"
              required
            />
          </div>
          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block text-sm font-medium mb-2 text-gray-200 flex items-center gap-2">
                <FaUserGraduate className="text-gray-400" /> Role
              </label>
              <select
                value={formData.role}
                onChange={(e) => setFormData({...formData, role: e.target.value})}
                className="w-full p-3 rounded-lg bg-gray-800 text-white focus:ring-2 focus:ring-green-500 focus:outline-none transition"
              >
                <option value="student">Student</option>
                <option value="coordinator">Coordinator</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-2 text-gray-200 flex items-center gap-2">
                <FaUniversity className="text-gray-400" /> Campus
              </label>
              <select
                value={formData.campus}
                onChange={(e) => setFormData({...formData, campus: e.target.value})}
                className="w-full p-3 rounded-lg bg-gray-800 text-white focus:ring-2 focus:ring-green-500 focus:outline-none transition"
              >
                <option value="Isulan">Isulan</option>
                <option value="ACCESS">ACCESS</option>
                <option value="Tacurong">Tacurong</option>
                <option value="Bagumbayan">Bagumbayan</option>
                <option value="Kalamansig">Kalamansig</option>
                <option value="Lutayan">Lutayan</option>
                <option value="Palimbang">Palimbang</option>
              </select>
            </div>
          </div>
          {formData.role === "student" && (
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-200 flex items-center gap-2">
                <FaIdBadge className="text-gray-400" /> Student ID
              </label>
              <input
                type="text"
                value={formData.studentId}
                onChange={(e) => setFormData({...formData, studentId: e.target.value})}
                className="w-full p-3 rounded-lg bg-gray-800 text-white focus:ring-2 focus:ring-green-500 focus:outline-none transition"
              />
            </div>
          )}
          {error && (
            <div className="text-red-400 text-sm text-center">{error}</div>
          )}
          <div className="flex gap-3 pt-2">
            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-green-600 px-4 py-3 rounded-lg font-semibold text-white hover:bg-green-700 focus:ring-2 focus:ring-green-400 focus:outline-none transition disabled:opacity-50 group relative"
            >
              <FaUserPlus className="inline mr-2 -mt-1" />
              {loading ? "Creating..." : "Create User"}
              <span className="absolute left-1/2 -translate-x-1/2 -bottom-8 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none z-50">Create a new user</span>
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-700 px-4 py-3 rounded-lg font-semibold text-white hover:bg-gray-600 focus:ring-2 focus:ring-gray-400 focus:outline-none transition group relative"
            >
              <FaTimes className="inline mr-2 -mt-1" /> Cancel
              <span className="absolute left-1/2 -translate-x-1/2 -bottom-8 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none z-50">Cancel and close</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 